import { render, staticRenderFns } from "./gl-checkbox.vue?vue&type=template&id=dbdbef94"
import script from "./gl-checkbox.vue?vue&type=script&lang=js"
export * from "./gl-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports